import React, { useEffect, useState } from "react";
import Decrement from "../images/increment.svg";
import Increment from "../images/decrement.svg";
import axios from "axios";
import { baseURL } from "../constants/Api";
import BackButton from "../pages/bars/BackButton";
import dateFormat from "dateformat";
import { checkTwoDates, CurrencySymbol, dateFormater, extractDatesfromArray, extractTimeFromDate, fetchRoomNoAndPhoneNo, handleOffers, setRoomNoAndPhoneNo, showDates, validatePhoneNumber } from "../utils/util";
import { useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { calanderBreakPoints } from "../constants/constant";
import EventAlert from "./alert/EventAlert";
import WarningMsg from "./alert/WarningMsg";
import { EventSubmitButtonClick } from "../utils/Analytics";

function EventForm({ selectedEventData, promotionId }) {
  //     eventV21
  // {
  //     "guestId": 216,
  //     "eventId": 4,
  //     "bookedFor": 2,
  //     "hotelId":14,
  //     "roomNumber": 250,
  //     "reservationId":1051,
  //     "appUserId":2
  // }
   const eventId = selectedEventData.id;
  const ticketsRemaining = selectedEventData.ticketsRemaining;
  const rate = selectedEventData?.rate;
  const offer = selectedEventData?.offer;
  const hotelId = localStorage.getItem("hotel-id");
  const reservationId = localStorage.getItem("reservationId");
  const guestId = localStorage.getItem("guestId");

  const appUserId = localStorage.getItem("appUserId");
   const [occupancy, setOccupancy] = useState(1);
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [remainingTickets, setRemainingTickets] = useState(
    selectedEventData?.ticketsRemaining
  );
  const isCheckedIn = localStorage.getItem("isCheckedIn");
  const storedData = fetchRoomNoAndPhoneNo();

  const [roomNo, setRoomNo] = useState(storedData?.room);
  const [mobileNo, setMobileNo] = useState(storedData?.phone ? storedData?.phone : localStorage.getItem("phone_no"));
  const [mobileValidation, setMobileValidation] =  useState(true);

  const [calendarDate, setCalendarDate] = useState([])
  const[selectedDate, setSelectedDate] = useState(null)
  const[showAlert, setShowAlert] = useState(false)
  const[loading, setLoading] = useState(false)
  const reservationData = JSON.parse(localStorage.getItem("guestDetailsArray"));
  const [showWarning, setShowWarning]= useState(false)
 
 
  const handleEventDate = (item)=>{
    console.log(reservationData?.dateOut,item?.date)
    setShowWarning(checkTwoDates(reservationData?.dateOut,item?.date)) 
    if (item?.active) {
      setSelectedDate(item);
      setError("");
      setOccupancy(1);
    }else{
      setShowAlert(true)
    }
  } 

  const handleOccupancyChange = (event) => {
    setError("");
    const value = event.target.value;
    if (value === "0") {
      // setError("Occupancy cannot be 0. Please enter a valid value.");
      return; 
    }
    if (/^\d*$/.test(value)) {
      setOccupancy(value); 
    }
  };
  

    useEffect(()=>{
       if(selectedEventData?.perDayRemaining.length){
          var filteredDates = extractDatesfromArray(selectedEventData?.perDayRemaining, selectedEventData?.from).filter((item)=> item?.active);
         setCalendarDate(filteredDates);
      }
       var dateArray = extractDatesfromArray(selectedEventData?.perDayRemaining, selectedEventData?.from);
       const firstActiveDate = dateArray.filter(item => item.active);
       if(firstActiveDate.length){
        setSelectedDate(firstActiveDate[0]);
       }
     
     },[selectedEventData])

   
  const navigate = useNavigate();

  const handleRoomNo = (e) => {
    setRoomNo(e.target.value);
    setError("");
  };

  const handleIncrment = () => {
    if (occupancy <= selectedDate?.remainingTicket) {
      setOccupancy((prev) => parseInt(prev || 0) + 1);
      setError("");
    }
  };

  const handleDecrment = () => {
    setError("");
    if (occupancy > 1) {
      setOccupancy((prev) => Math.max(0, parseInt(prev || 0) - 1));
    }
  };

  const handleMobile = (number)=>{
    console.log(number)
    setMobileNo(number)
    setError("");
    setMobileValidation(validatePhoneNumber(number))
  }


  const bookEvent = async () => {
    var amount;
    if(offer){
      amount =  handleOffers(rate, parseInt(offer)) * occupancy;
    }else{
      amount = rate * occupancy
    }
    try {
      setLoading(true);
      await axios({
        method: "post",
        url: `${baseURL}/api/eventV21`,
        data: {
          guestId,
          eventId,
          bookedFor: occupancy,
          hotelId,
          roomNumber: roomNo,
          reservationId,
          appUserId,
          contactName : mobileNo,
          amount,
          promotionId,
          bookingDate: selectedDate?.date
          
        },
        headers: { "Content-Type": "application/json" },
      }).then(function (response) {
        console.log(response);
        if (response.data.success != true) { 
          setError(response.data?.message); 
          setLoading(false);
        } else {
          setRemainingTickets(remainingTickets - occupancy);
          setError("");
          setSuccess(true);
          setRoomNoAndPhoneNo(roomNo,mobileNo)

          setRoomNo("");
          setComment("");
          setOccupancy(1);
          setMobileNo("")
          setRoomNoAndPhoneNo(roomNo,mobileNo)

          setTimeout(() => {
            setSuccess(false);
            navigate("../order-history");
            setLoading(false);
          }, 2000);
        }
      });
    } catch (error) {
      console.error(error);
      setError("axios");
      setLoading(false);
    }
  };

  const submitEvent = (e) => {
    e.preventDefault();
    if(isCheckedIn === "true" && roomNo === "") {
      setError("validation");
    } else if (occupancy > selectedDate?.remainingTicket) {
      setError("ticketValidation");
      setTimeout(() => {
        setError("");
      }, 2000);
      
    }else if(isCheckedIn === "true" && mobileNo === ""){
      setError("mobValidation");
    }else if(!mobileValidation){
      setError("Invalid number");
    } else if(!selectedDate){
      setError("give date");
    }
    else if(occupancy == 0 ) {
      setError("occupancy is Zero")
    }else{
      EventSubmitButtonClick();
      bookEvent();
    }
  };

  useEffect(() => {
    if (occupancy > remainingTickets) setError("exceed");
  }, [occupancy]);

   // currency setup
  const currencySymbol = CurrencySymbol();
  return (
    <div className=" pb-5 relative event-data">
      <div>
        <div
          style={{
            width: "100%",
            height: "150px",
            maxHeight: "200px",
            backgroundImage: `url(${selectedEventData.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
        <div className="absolute top-3 left-3">
          <BackButton whiteTheme={true}/>
        </div>
        
        <div className="section-wrap  mx-4 mt-6 sm:mt-10">
          <div className="guestName text-left">Request </div>
          <div className="mt-6 text-base font-semibold">
            {selectedEventData.name}
          </div>
          <div className="text-[#D3D3D3] font-medium text-sm mt-2">
           <span className="mr-2"> Event Date:-</span>
            {dateFormater(selectedEventData.from, "dd-mm-yyyy")}
            <span className="mx-2">to</span>
            {dateFormater(selectedEventData.to, "dd-mm-yyyy")}
          </div>
          {/* <div className="text-[#D3D3D3] font-medium text-sm mt-2">
            {selectedDate?.remainingTicket !== 0  ?<span className="mr-2"> Tickets Remaining- {selectedDate?.remainingTicket} </span>
            :<span className="mr-2"> Sold out</span>}
          </div> */}
          <Carousel
       responsive={calanderBreakPoints}
      >
        {calendarDate.map((item, i) => {
          return (
            <div>
            <div className={selectedDate?.day == item?.day ? "calendar-div-active mt-3" : "calendar-div mt-3" }  
            onClick={() =>handleEventDate(item)} >
                <div className="w-6/12 text-center flex-wrap flex">{item?.day}</div> 
            </div>
         {item?.active &&
         <div>
          {item?.remainingTicket != 0 ? <div className="text-[10px] mt-1 text-center leading-3">  {item?.remainingTicket} <br/>{item?.remainingTicket > 1 ? 'tickets' : 'ticket'} left</div>
                :<div className="text-[10px] mt-1 text-center leading-3">Sold out</div> 
          }
            </div>
            }
            </div>
          );
        })}
        </Carousel>
        {selectedDate && <div className="mt-6 p-3 reqInput text-xs">{selectedDate?.day} <span className="ml-3">{extractTimeFromDate(selectedEventData?.from)}-</span> <span>{extractTimeFromDate(selectedEventData?.to)}</span></div>}


           <form onSubmit={submitEvent} className="flex flex-col mt-5">
          { offer ?
                <div className="flex item-center gap-3">
                  <div style={{color:"#a69e9e"}}>Rate : <span className="line-through"> {currencySymbol} {occupancy ? rate * occupancy : rate}</span></div>
                  <div>{currencySymbol} {   
                 occupancy ?  (handleOffers(rate, parseInt(offer)) * occupancy).toFixed(2) :  handleOffers(rate, parseInt(offer))
                 }</div>
                </div> 
                  : <div><span><span className="mt-4 text-left text-[#D0D0D0] text-12px font-normal"> Rate:</span> </span>{rate == 0 ? <span>Free</span> : <span>₹{occupancy ? rate* occupancy : rate}</span>}</div> 
              }
            <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Occupancy   
            </label>
              {/* <div className="text-sm font-medium">{occupancy} Person</div> */}
            <div className="mt-2  flex items-center justify-between relative">
              <input
                type="text"
                value={occupancy}
                onChange={handleOccupancyChange}
                className="reqInput"
              />

              <div className="flex absolute space-x-6 items-center right-2">
                <div onClick={handleDecrment} className="cursor-pointer">
                  <img src={Decrement} />
                </div>
                <div onClick={handleIncrment} className="cursor-pointer">
                  <img src={Increment} />
                </div>
               
              </div>
              {error === "exceed" && (
                <div className="absolute text-xs text-red-500 -bottom-5 left-0">
                  Occupancy reached the limit
                </div>
              )}
            </div>
            {isCheckedIn==="true" && <div className="mt-4">
              <label className="mt-8 text-left text-[#D0D0D0] text-12px font-normal">
                          Room Number
                        </label>
                        <input
                          onChange={handleRoomNo}
                          className="mt-2 reqInput"
                          type="text"
                          value={roomNo}
                        />
            </div> }
            <div className="mt-3">
              
              <label className="mt-6 text-left text-[#D0D0D0] text-12px font-normal">
                          Mobile number
                        </label>
                        <input
                          onChange={(e)=>handleMobile(e.target.value)}
                          className="mt-2 reqInput"
                          type="text"
                          value={mobileNo}
                        />
                      {!mobileValidation && <span className="text-red-500 text-sm">Invalid number</span>}
              </div>
           
            {/* <label className="mt-6 text-left text-[#D0D0D0] text-12px font-normal">
              Comment if any
            </label>
            <textarea
              className="mt-2 reqInput"
              type="textarea"
              value={comment}
            /> */}
            <button disabled ={loading} style={{background: loading ? "#6f6cb6" : "#5550d2"}} className="bookBtn mt-10">Book Now</button>
            <div className="mt-10 fixed  bottom-5 left-1/2 -translate-x-1/2">
              {error == "validation" && (
                <div className="w-full flex justify-center">
                  <div className="error-doc text-center mt-3">
                    Please enter room number..
                  </div>
                </div>
              )}

               {error == "mobValidation" && (
                <div className="w-full flex justify-center">
                  <div className="error-doc text-center mt-3">
                    Please enter phone number..
                  </div>
                </div>
              )}

              {error == "ticketValidation" && (
                <div className="w-full flex justify-center">
                  <div className="error-doc text-center mt-3">
                    There is no tickets remaining
                  </div>
                </div>
              )}

              {error == "axios" && (
                <div className="w-full flex justify-center">
                  <div className="error-doc text-center mt-3">
                    Somthing went wrong..
                  </div>
                </div>
              )}

             {error != "ticketValidation" && error == "axios" && (
                  <div className="w-full flex justify-center">
                  <div className="error-doc text-center mt-3">
                    {error}
                  </div>
                </div>
              )}
              {error == "occupancy is Zero" && (
                <div className="w-full flex justify-center">
                    <div className="error-doc text-center mt-3">
                      Occupancy cannot be 0. Please enter a valid value.
                    </div>
                </div>
              )}

              {success && (
                <div className="w-full flex justify-center">
                  <div className="success-doc text-center mt-3">
                    Successfully booked
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
      {showAlert && <EventAlert hideModal={()=>setShowAlert(false)}/>}
      {showWarning && <WarningMsg messageContent="Selected date is after your check out time, no worries your tickets will be available on the profile page." hideModal = {()=>setShowWarning(false)}/>}
    </div>
  );
}

export default EventForm;
